/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagecheckedin3Inputs */

const en_ticketpagecheckedin3 = /** @type {(inputs: Ticketpagecheckedin3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checked in`)
};

const de_ticketpagecheckedin3 = /** @type {(inputs: Ticketpagecheckedin3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingecheckt`)
};

/**
* | output |
* | --- |
* | "Checked in" |
*
* @param {Ticketpagecheckedin3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagecheckedin3 = /** @type {((inputs?: Ticketpagecheckedin3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagecheckedin3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagecheckedin3(inputs)
	return de_ticketpagecheckedin3(inputs)
});
export { ticketpagecheckedin3 as "ticketPageCheckedIn" }